import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const AchievementsModalLazy = React.lazy(() =>
  import('./AchievementsModal').then((m) => ({ default: m.AchievementsModal })),
);

NiceModal.register(
  MODALS.ACHIEVEMENTS,
  NiceModal.create(() => (
    <Suspense fallback={null}>
      <AchievementsModalLazy />
    </Suspense>
  )),
);
